export type FAQItem = {
  q: string;
  a: string;
};

export type FAQCategory = {
  category: string;
  description: string;
  iconName: string;
  items: FAQItem[];
};

export const faqCategories: FAQCategory[] = [
  {
    category: "Immobilienbewertung & Kosten",
    description: "Alles über die Wertermittlung, Marktgerechtigkeit und kostenlose Services für Eigentümer.",
    iconName: "TrendingUp",
    items: [
      {
        q: "Was kostet eine Immobilienbewertung in Brackenheim, Güglingen oder dem Zabergäu?",
        a: "Die professionelle Immobilienbewertung durch Andrea Heinz (Immozwerg) ist für Eigentümer vollkommen kostenlos und unverbindlich – egal ob in Brackenheim, Güglingen, Lauffen, Schwaigern oder Heilbronn. Ich analysiere Ihre Immobilie fundiert anhand aktueller Vergleichsdaten und regionaler Marktkenntnis.",
      },
      {
        q: "Wie ermitteln Sie den realistischen Marktwert einer Immobilie?",
        a: "Ich nutze eine Kombination aus Vergleichswertverfahren, Ertragswertverfahren bzw. Sachwertverfahren, beziehe aktuelle Transaktionsdaten aus der Region Brackenheim/Güglingen ein und berücksichtige den konkreten Zustand sowie Modernisierungen.",
      },
      {
        q: "Warum ist regionale Marktkenntnis in Güglingen & Brackenheim entscheidend?",
        a: "Der Immobilienmarkt im Zabergäu unterscheidet sich spürbar von Stuttgart oder Heilbronn. Lokale Faktoren wie Lage im Weinbaugebiet, Bodenrichtwerte, Nachfrage vor Ort sowie regionale Käuferstrukturen bestimmen den exakten Verkaufserfolg.",
      },
      {
        q: "Welche Unterlagen benötige ich für eine fundierte Bewertung?",
        a: "Grundlegend helfen ein aktueller Grundbuchauszug, Flurkarte, Baupläne und Wohnflächenberechnungen. Sollten Unterlagen fehlen, unterstütze ich Sie bei der Beschaffung – ganz unkompliziert als Teil unseres gemeinsamen Weges.",
      },
    ],
  },
  {
    category: "Verkaufsprozess & Dauer",
    description: "Vom ersten Kennenlernen über die Vermarktung bis zur erfolgreichen Schlüsselübergabe.",
    iconName: "Home",
    items: [
      {
        q: "Wie lange dauert ein Immobilienverkauf in der Region Heilbronn & Zabergäu?",
        a: "Im Durchschnitt dauert ein professionell begleiteter Verkauf in Brackenheim, Güglingen und Umgebung 2 bis 4 Monate vom ersten Kennenlernen bis zur erfolgreichen Schlüsselübergabe beim Notar.",
      },
      {
        q: "Welche Unterlagen benötige ich für den erfolgreichen Verkauf?",
        a: "Dazu gehören unter anderem der aktuelle Grundbuchauszug, ein gültiger Energieausweis, maßstabsgetreue Grundrisse, Flurkarte sowie bei Eigentumswohnungen die Teilungserklärung und Protokolle der Eigentümerversammlungen. Ich unterstütze Sie bei der Beschaffung.",
      },
      {
        q: "Wie läuft die Zusammenarbeit mit Immozwerg von A bis Z ab?",
        a: "Wir starten mit einem kostenlosen Erstgespräch. Danach ermittle ich den marktgerechten Wert, erstelle professionelle Fotos und ein aussagekräftiges Exposé, übernehme die Vermarktung, führe strukturierte Besichtigungen durch und begleite Sie sicher bis zum Notartermin.",
      },
      {
        q: "Wie werden Besichtigungen organisiert und durchgeführt?",
        a: "Kein massenhafter Besichtigungstourismus. Ich prüfe Interessenten im Vorfeld auf Bonität und echtes Kaufinteresse, plane strukturierte Einzeltermine und präsentiere Ihr Objekt im besten Licht.",
      },
      {
        q: "Wie lange dauert es vom Notartermin bis zur Schlüsselübergabe?",
        a: "In der Regel dauert es 4 bis 8 Wochen. Sobald die Auflassungsvormerkung im Grundbuch eingetragen ist, die Unbedenklichkeitsbescheinigung des Finanzamts vorliegt und der Kaufpreis vollständig bezahlt wurde, findet die offizielle Übergabe statt.",
      },
    ],
  },
  {
    category: "Käufer & Maklerprovision",
    description: "Alles zu Provisionsregelungen, Kaufbegleitung und Bonitätsprüfung.",
    iconName: "Users",
    items: [
      {
        q: "Arbeiten Sie als Maklerin auch mit Immobilienkäufern zusammen?",
        a: "Ja! Ich betreue sowohl Verkäufer als auch Kaufinteressenten in Brackenheim, Güglingen, Heilbronn und Stuttgart. Als Käufer profitieren Sie von meinem regionalen Netzwerk, transparenter Objektprüfung und Begleitung bis zum Notar – inklusive Finanzierungs- und Fördercheck.",
      },
      {
        q: "Wer trägt die Maklerprovision nach der gesetzlichen Neuregelung?",
        a: "Bei der Vermittlung von Wohnungen und Einfamilienhäusern an Verbraucher gilt das Bestellerprinzip bzw. die hälftige Teilung (§ 656a–d BGB). In der Region Heilbronn und Zabergäu teilt sich die Gesamtprovision von meist 7,14 % inkl. MwSt. fair auf Käufer und Verkäufer auf (jeweils max. 3,57 %).",
      },
      {
        q: "Welche Unterstützung bieten Sie beim Thema Finanzierung?",
        a: "Zwar vergebe ich selbst keine Kredite, arbeite jedoch eng mit erfahrenen Finanzierungsexperten (wie Baufipur) zusammen. Wir prüfen Förderungen (z. B. KfW) und unterstützen Käufer dabei, ihre Finanzierung schnell und solide aufzustellen.",
      },
    ],
  },
  {
    category: "Besondere Situationen (Erbschaft & Scheidung)",
    description: "Einfühlsame und neutrale Begleitung bei sensiblen Immobilienthemen.",
    iconName: "Shield",
    items: [
      {
        q: "Wie unterstützen Sie Erbengemeinschaften bei Erbschaftsimmobilien?",
        a: "Ich begleite Erbengemeinschaften in Brackenheim, Güglingen und im gesamten Zabergäu einfühlsam und absolut neutral. Ob Wertermittlung für das Nachlassgericht, Verkauf, Vermietung oder Eigennutzung – ich koordiniere alle Beteiligten und sorge für einen reibungslosen Ablauf.",
      },
      {
        q: "Wie verhält es sich bei einem Immobilienverkauf im Rahmen einer Scheidung?",
        a: "Eine Scheidung ist emotional belastend. Ich agiere als neutrale Vermittlerin zwischen den Parteien, ermittle den marktgerechten Wert und begleite den Verkauf oder die Übernahme lösungsorientiert und diskret, um den Prozess so stressfrei wie möglich zu gestalten.",
      },
      {
        q: "Sollte ich meine Immobilie vor dem Verkauf noch renovieren?",
        a: "Meistens lohnt sich eine teure Kernsanierung vor dem Verkauf finanziell nicht. Oft reichen kleine Schönheitsreparaturen, ein frischer Anstrich oder ein gepflegter Garten aus. Ich berate Sie individuell, welche Maßnahmen sich wirklich rentieren.",
      },
      {
        q: "Welche Rolle spielt der Energieausweis beim Hausverkauf?",
        a: "Der Energieausweis ist gesetzlich vorgeschrieben und muss bereits bei der Besichtigung (bzw. im Exposé) vorliegen. Es wird zwischen Bedarfsausweis und Verbrauchsausweis unterschieden. Ich helfe Ihnen unkompliziert bei der Ausstellung über zertifizierte Partner.",
      },
      {
        q: "Was unterscheidet Immozwerg von anderen Maklern im Zabergäu?",
        a: "Tacheles statt Kuschelkurs. Ich sage Ihnen ehrlich, was Ihre Immobilie wert ist und welche Strategie funktioniert – ohne leere Versprechen oder künstlich überhöhte Startpreise. Dafür stehe ich mit meinem Namen und echter Leidenschaft.",
      },
    ],
  },
];

export const allFAQs = faqCategories.flatMap(cat => cat.items);
